export const dataURLtoBlob = (dataURL: string): Blob => {
  try {
    if (typeof dataURL !== 'string') {
      throw new TypeError('Input must be a string.')
    }

    const base64Marker = ';base64,'
    const parts = dataURL.split(base64Marker)

    if (parts.length !== 2) {
      throw new Error('Invalid data URL format.')
    }

    const contentTypeMatch = parts[0].match(/^data:(.*)$/)
    if (!contentTypeMatch || !contentTypeMatch[1]) {
      throw new Error('Content type could not be determined.')
    }
    const contentType = contentTypeMatch[1]

    let raw: string
    try {
      raw = window.atob(parts[1])
    } catch (e) {
      throw new Error('Base64 decoding failed.')
    }

    const rawLength = raw.length
    const uInt8Array = new Uint8Array(rawLength)

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i)
    }

    return new Blob([uInt8Array], { type: contentType })
  } catch (error) {
    console.error('dataURLtoBlob error:', error)
    throw error
  }
}
